export const emergencyPersonnelSelector = state => state.emergencyPersonnel.get('emergencyPersonnel');
export const emergencyDetailsSelector = state => state.emergencyPersonnel.get('details');
export const isLoadingSelector = state => state.emergencyPersonnel.get('isLoading');

